import * as allLocales from 'react-day-picker/locale';

type LocaleKey = keyof typeof allLocales;

export const getLocaleFromString = (localeString?: string) => {
  if (!localeString) return allLocales.enUS;

  // Convert locale string to react-day-picker locale key format
  // e.g., 'en-US' -> 'enUS', 'sv-SE' -> 'sv', 'zh-CN' -> 'zhCN'
  const languageCode = localeString.split('-')[0]; // e.g., 'sv-SE' -> 'sv'
  const languageAndRegionCodeWithoutDash = localeString.replace('-', ''); // e.g. 'sv-SE' -> 'svSE'

  if (languageCode === 'no') {
    return allLocales.nb; // Map 'no' to 'nb' for Norwegian Bokmål
  }

  // Try to find the locale using language code first, then language and region code, otherwise default to 'enUS'
  return (
    allLocales[languageCode as LocaleKey] ||
    allLocales[languageAndRegionCodeWithoutDash as LocaleKey] ||
    allLocales.enUS
  );
};
